import React from "react";
import { hotelAttributes, roomAttributes } from "../utils";
import { useSelector, useDispatch } from "react-redux";
import { MdCheck } from "react-icons/md";

import { FaInfoCircle } from "react-icons/fa";
import InfoPopupHover from "../components/InfoPopupHover";
import { setSelectedRoomAttributes } from "amadeusredux/lib/filterSlice";

export default function RoomAttributeFilter(props) {

  const dispatch = useDispatch();

  const selectedRoomAttributes = useSelector(
    (state) => state.filter.selectedRoomAttributes
  );

  const roomAttributesFilter = useSelector(
    (state) => state.filter.roomAttributesFilter
  );


  let { offersRoomAttributesAfterFilter, offersRoomAttributes } =
    roomAttributesFilter;

  

  if (!offersRoomAttributesAfterFilter) {
    offersRoomAttributesAfterFilter = {};
  }

  if (!offersRoomAttributes) {
    offersRoomAttributes = {};
  }

  const [showAll, setShowAll] = React.useState(false);
  //console.log(filteredItems);

  const loading = useSelector((state) => state.system.loading);
  //console.log(attributes);

  let ct = 0;
  return (
    <div
      className="hptelattributefilter "
      style={{
        border: "1px solid #d0d0d0",
        backgroundColor: "white",
        marginBottom: 16,
        marginTop: 16,
        padding: 16,
      }}
    >
      <span className="roomtypefilter1 filterheader">Zimmerattribut</span>

      {Object.keys(offersRoomAttributes).map((itm, idx) => {
        let disabled = false;

        if (!Object.keys(offersRoomAttributesAfterFilter).includes(itm))
          disabled = true;

        if (selectedRoomAttributes.includes(itm)) disabled = false;

        if (loading) disabled = true;

        ct = ct + 1;

        if (ct > 5 && !showAll) return null;

        return (
          <React.Fragment key={idx}>
            {
              <>
                <div className="filterrow" key={itm}>
                  <div className="filter1">
                    <input
                      className="hotelattributefilter4"
                      checked={selectedRoomAttributes.includes(itm)}
                      onChange={() => {
                        if (selectedRoomAttributes.includes(itm)) {
                          let tmpAtt = [];
                          for (
                            let i = 0;
                            i < selectedRoomAttributes.length;
                            i++
                          ) {
                            if (selectedRoomAttributes[i] !== itm) {
                              tmpAtt.push(selectedRoomAttributes[i]);
                            }
                          }
                          dispatch(setSelectedRoomAttributes(tmpAtt));
                        } else {
                          dispatch(
                            setSelectedRoomAttributes([
                              ...selectedRoomAttributes,
                              itm,
                            ])
                          );
                        }
                      }}
                      disabled={disabled}
                      type="checkbox"
                    />
                  </div>
                  <div className="filter2">
                    <div className="filtertext">
                      {offersRoomAttributes[itm].label} (
                      {offersRoomAttributesAfterFilter[itm]
                        ? offersRoomAttributesAfterFilter[itm].count
                        : 0})
                    </div>
                  </div>
                </div>
              </>
            }
          </React.Fragment>
        );
      })}

      {!showAll && ct > 5 && (
        <div style={{ cursor: "pointer" }} onClick={() => setShowAll(true)}>
          alle anzeigen
        </div>
      )}
      {showAll && (
        <div style={{ cursor: "pointer" }} onClick={() => setShowAll(false)}>
          weniger anzeigen
        </div>
      )}
    </div>
  );
}
